import { AnyAction, Middleware } from 'redux';

import { createAnalyticsTracker } from './analyticsTracker';

export default (debug: boolean): Middleware => {
  const analyticsTracker = createAnalyticsTracker(debug);

  return () => next => (action: AnyAction) => {
    next(action);

    if (!action.meta || !action.meta.analytics) {
      return;
    }

    const { type, payload } = action.meta.analytics;

    switch (type) {
      case 'logout':
        analyticsTracker('reset');

        if (global.mixpanel && global.mixpanel.cookie) {
          global.mixpanel.cookie.clear();
        }
        break;
      case 'page':
        analyticsTracker('page', payload.traits, payload.options);
        break;
      case 'identify':
        analyticsTracker('identify', payload.aliasId, payload.data);
        break;
      case 'alias':
        analyticsTracker('alias', payload);
        break;
      default:
        if (payload.options) {
          analyticsTracker('track', type, payload, payload.options);
        } else {
          analyticsTracker('track', type, payload);
        }
    }
  };
};
